export default "__VITE_ASSET__62c331ad__"